import styled from "../../util/styled";

const PREFIX = "PriceCalculator";

export const classes = {
  marginBottom: `${PREFIX}-marginBottom`,
  form: `${PREFIX}-inputWrapper`,
  button: `${PREFIX}-button`,
  contained: `${PREFIX}-contained`,
  outlined: `${PREFIX}-outlined`,
  details: `${PREFIX}-details`,
  bold: `${PREFIX}-amount`,
};

export const Root = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  [`& .${classes.marginBottom}`]: {
    marginBottom: theme.spacing(2),
  },
  [`& .${classes.form}`]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [`& > div, & .${classes.button}`]: {
      margin: theme.spacing(0, 2),
    },
    [`& .${classes.button}`]: {
      padding: theme.spacing(),
      fontSize: theme.typography.caption.fontSize,
      [`&.${classes.contained}`]: {
        backgroundColor: theme.palette.innoGrey.main,
        color: theme.palette.innoGrey.contrastText,
        "&:hover": {
          backgroundColor: theme.palette.innoGrey.light,
          color: theme.palette.innoGrey.dark,
        },
      },
      [`&.${classes.outlined}`]: {
        color: theme.palette.innoGrey.main,
        borderColor: theme.palette.innoGrey.main,
        "&:hover": {
          backgroundColor: theme.palette.innoGrey.light,
          color: theme.palette.innoGrey.dark,
        },
      },
    },
  },
  [`& .${classes.bold}`]: {
    fontWeight: 600,
  },
}));
